"use client";

import { parseAsString, useQueryState } from "nuqs";
import React from "react";

import insuranceSearchStyles from "../InsuranceSearch.module.css";

export const SearchFeedback: React.FC<{ totalItems: number }> = ({ totalItems }) => {
  const [queryValue] = useQueryState("query", parseAsString.withDefault(""));

  if (!queryValue) {
    return null;
  }

  const resultText =
    totalItems > 0 ? `${totalItems} ${totalItems === 1 ? "träff" : "träffar"}` : "inga träffar";

  return (
    <div aria-live="polite" role="region" aria-atomic="true">
      <div className={insuranceSearchStyles.screenReaderWrapper}>
        <p>
          {queryValue} gav {resultText}
        </p>
      </div>
    </div>
  );
};
